import React from "react";
import Transaction from "../../../../../../../models/transaction";

interface Props {
	dataType: string;
	transaction: Transaction;
}

function TransactionDetailCardNIP({dataType, transaction}: Props): JSX.Element {
	return (
		<>
			{transaction && transaction.nipSessionId && (
				<div className="flex w-full flex-row items-start justify-between" data-type={dataType}>
					<p className="text-sm text-black-secondary" data-type={dataType}>
						NIP Session ID
					</p>
					<p className="max-w-55% whitespace-normal break-words text-right text-sm font-medium text-black-secondary" data-type={dataType}>
						{transaction.nipSessionId}
					</p>
				</div>
			)}
		</>
	);
}

export default TransactionDetailCardNIP;
